import { BaseDiv } from "./BaseDom";
import videojs, { VideoJsPlayer } from "video.js";
import { IOptions, RiskData, TextData } from "../type";

export default class RiskTimeline extends BaseDiv {
  constructor(player: VideoJsPlayer, opts?: IOptions) {
    super(player);
    this.addClass("vjs-risk-timeline");
    const riskData = opts?.risk || {};
    const textData = (opts?.text || []) as [];
    const divHeight = opts?.height || 30;
    const timeline = new RiskDataTimeline(riskData, textData);
    const timeTicks = timeline.startTimeTicks;
    const riskValues = timeline.riskValues("avg");
    const riskColors = riskValues.map((_val) => getRiskColorAvg(_val));
    videojs.registerComponent("RiskColorBlock", RiskDiv);
    this.setStyle({
      position: "absolute",
      bottom: `-${divHeight}px`,
      display: "flex",
      flexDirection: "row",
      width: "100%",
      height: `${divHeight}px`,
    });
    riskColors.forEach((color, idx) => {
      this.addChild("RiskColorBlock", { color: color, time: timeTicks[idx] });
    });
  }
}

class RiskDiv extends BaseDiv {
  constructor(player: VideoJsPlayer, opts?: IOptions) {
    super(player);
    const time = (opts?.time || 0) as number;
    const color = opts?.color || "#fff";
    // 同步视频时间轴
    videojs.on(this.el(), "click", () => {
      player.currentTime(time);
      player.play();
    });
    this.setStyle({
      flex: "auto",
      border: "1px #fff solid",
      background: `${color}`,
    });
  }
}

// Hard code
function getRiskColorAvg(riskValue) {
  if (riskValue < 0.01) {
    // return "#a1d99b";
    return "#d9d9da";
  }
  if (riskValue < 0.1) {
    // return "#fdbb84";
    return "#fdb462";
  }
  // return "#e34a33";
  return "#80b1d3";
}

export class RiskDataTimeline {
  riskData: RiskData;
  textData: TextData;
  constructor(riskData: RiskData, textData: TextData) {
    this.riskData = riskData;
    this.textData = textData;
  }

  riskValues(stat = "sum"): number[] {
    const riskValues = [];
    const startTimeTicks = this.startTimeTicks;
    const endTimeTicks = this.endTimeTicks;
    if (startTimeTicks.length === endTimeTicks.length) {
      for (let i = 0, len = startTimeTicks.length; i < len; i++) {
        const _startTime = startTimeTicks[i];
        const _endTime = endTimeTicks[i];
        let _riskValue = 0;
        switch (stat) {
          case "avg":
            _riskValue = this.getRiskAvg(_startTime, _endTime);
            break;
          case "max":
            _riskValue = this.getRiskMax(_startTime, _endTime);
            break;
          default:
            _riskValue = this.getRiskSum(_startTime, _endTime);
            break;
        }
        riskValues.push(_riskValue);
      }
    }
    return riskValues;
  }

  get startTimeTicks() {
    const startTimeTicks = this.textData.map((textItem) => textItem.start);
    if (startTimeTicks.length > 0) {
      startTimeTicks.sort((a, b) => a - b);
      startTimeTicks[0] = 0;
    }
    return startTimeTicks;
  }

  get endTimeTicks() {
    const endTimeTicks = this.textData.map((textItem) => textItem.end);
    if (endTimeTicks.length > 0) {
      endTimeTicks.sort((a, b) => a - b);
    }
    return endTimeTicks;
  }

  getRiskSum(startTime, endTime) {
    const { riskData } = this;
    let riskSum = 0;
    for (const riskLabel in riskData) {
      const riskTS = riskData[riskLabel];
      for (const time in riskTS) {
        if (+time >= startTime && +time <= endTime) {
          const riskValue = riskTS[time];
          if (riskValue > 0) {
            riskSum += riskValue;
          }
        }
      }
    }
    return Math.ceil(riskSum);
  }

  getRiskMax(startTime, endTime) {
    const { riskData } = this;
    let riskMax = 0;
    for (const riskLabel in riskData) {
      const riskTS = riskData[riskLabel];
      for (const time in riskTS) {
        if (+time >= startTime && +time <= endTime) {
          const riskValue = riskTS[time];
          if (riskValue > riskMax) {
            riskMax = riskValue;
          }
        }
      }
    }
    return riskMax;
  }

  getRiskAvg(startTime, endTime) {
    const { riskData } = this;
    let riskAvg = 0,
      count = 0;
    for (const riskLabel in riskData) {
      const riskTS = riskData[riskLabel];
      for (const time in riskTS) {
        if (+time >= startTime && +time <= endTime) {
          const riskValue = riskTS[time];
          if (riskValue > 0) {
            riskAvg += riskValue;
            count++;
          }
        }
      }
    }
    return riskAvg > 0 ? riskAvg / count : riskAvg;
  }
}
